import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import axiosConfig from "../Service/axiosConfig";
import useDebouncedValue from "../Utils/Debounce";
import { MdDeleteOutline, MdOutlineEdit } from "react-icons/md";
import { FaHandHoldingHeart } from "react-icons/fa";
import "./master_categories.css";

const Orders = () => {
  const [loading, setLoading] = useState(false);
  const [Data, SetData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [RowPerPage, setRowPerPage] = useState(30);
  const [search, SetSearch] = useState({
    search: "",
  });
  const debouncedSearchTerm = useDebouncedValue(search.search, 500);

  const GetData = async () => {
    setLoading(true);
    try {
      const response = await axiosConfig.get(
        `/accounts/orderdetails/?page=${currentPage}&page_size=${RowPerPage}&search=${debouncedSearchTerm}`
      );
      SetData(response.data.results);
      setTotalRows(response.data.count);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    GetData();
  }, [currentPage, RowPerPage, debouncedSearchTerm]);

  // Handle search input change
  const HandleSearch = (e) => {
    e.preventDefault();
    const name = e.target.name;
    const value = e.target.value;
    SetSearch({ ...search, [name]: value });
  };

  // Handle sorting
  const handleSort = (column, direction) => {
    console.log(column.selector, direction);
    axiosConfig
      .get(
        `/accounts/orderdetails/?page=${currentPage}&page_size=${RowPerPage}&ordering=${
          direction === "asc" ? column.selector : `-${column.selector}`
        }`
      )
      .then((res) => {
        SetData(res.data.results);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const columns = [
    {
      name: "S.No",
      selector: "id",
      cell: (row, i) => (currentPage - 1) * RowPerPage + i + 1,
      sortable: true,
    },

    {
      name: "Name",
      selector: "name",
      cell: (row) => row.course?.category_ref?.name,
      sortable: true,
    },

    {
      name: "Image",
      cell: (row) => (
        <img
          src={row.course?.image?.image}
          alt={row.course?.image?.image}
          style={{ width: "100px", height: "100px" }}
        />
      ),
      sortable: true,
    },

    {
      name: "Price",
      selector: "fee",
      cell: (row) => row.price,
      sortable: true,
    },
    {
      name: "Total Amount",
      selector: "total_amount",
      cell: (row) => row.total_amount,
      sortable: true,
    },
  ];
  console.log(Data, "data");
  return (
    <div className="table-responsive marginTop">
      <DataTable
        columns={columns}
        data={Data}
        pagination
        paginationTotalRows={totalRows}
        paginationPerPage={RowPerPage}
        paginationDefaultPage={currentPage}
        onChangePage={(page) => setCurrentPage(page)}
        paginationPerPageOptions={[10, 20, 25, 30, 40, 50]}
        paginationRowsPerPageOptions={[10, 20, 25, 30, 40, 50]}
        onChangeRowsPerPage={(RowsPerPageChange) =>
          setRowPerPage(RowsPerPageChange)
        }
        onSort={handleSort}
        paginationServer
        fixedHeader
        subHeader
        customStyles={{
          rows: {
            style: {},
          },
          cells: {
            style: {
              justifyContent: "center",
            },
          },
          headCells: {
            style: {
              color: "#5C5C5C",
              justifyContent: "center",
              color: "rgb(33,37,41)",
              fontSize: "12px",
              fontWeight: 500,
              lineHeight: "28px",
            },
          },
        }}
        progressPending={loading}
        progressComponent={
          <div className="loader-container">
            <img
              src={require("../Components/FormParser/images/loader2.gif")}
              alt="Loading..."
            />
          </div>
        }
      />
    </div>
  );
};

export { Orders };
